<template>
	<div>
		<v-text-field :label="label" v-model="currentValue" @blur="update()" :hint="hint">
		</v-text-field>
	</div>
</template>

<script>
export default {
	props: {
		label: "",
		value: null,
		hint: "",
	},

	data() {
		return {
			currentValue: "",
		};
	},

	mounted() {
		this.setInitialValue();
	},

	watch: {
		value() {
			this.setInitialValue();
		},
	},

	methods: {
		setInitialValue() {
			this.value.split(".");
			this.currentValue = this.value.split(".")[0];
		},

		update() {
			if (this.value !== this.currentValue) {
				if (!this.currentValue || this.currentValue.length === 0) {
					this.$emit("valueChanged", null);
				} else {
					const parts = this.currentValue.split(":");
					if (parts.length == 3) {
						this.$emit("valueChanged", this.currentValue);
					} else {
						this.setInitialValue();
					}
				}
			}
		},
	},
};
</script>

<style scoped></style>
